exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-card[data-v-23a9a552] {\n  width: 300px;\n  height: 50vh;\n  overflow-y: auto;\n}", ""]);

// exports
